// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import type { ViewportCategory } from '@ta/common.state';
import type { MemberInfo } from '@ta/social.member-types';

import type { Profile } from './types';
import ProfileCardNarrow from './profile-narrow/ProfileCardNarrow';
import ProfileCardWide from './profile-wide/ProfileCardWide';

/**
 * Renders a Wide card on Desktop and Tablet, and a narrow card on Mobile
 */
type Props = {|
  profile: Profile,
  memberInfo?: MemberInfo,
|};

type InternalProps = {|
  ...Props,
  device: ViewportCategory, // Internal prop. Read from redux
|};

const ProfileCardResponsive = (props: InternalProps) =>
  props.device === 'MOBILE' ? (
    <ProfileCardNarrow profile={props.profile} memberInfo={props.memberInfo} />
  ) : (
    <ProfileCardWide profile={props.profile} memberInfo={props.memberInfo} />
  );

ProfileCardResponsive.defaultProps = {
  memberInfo: undefined,
};

// $FlowFixMe92
export default connect(redux => ({
  device: redux.meta.device.viewportCategory,
}))(ProfileCardResponsive);
